import React, { useContext } from "react";
import { useQueryClient } from "react-query";
import { UserInfoContext } from "../../../WSUtils/UserInfoContext";
import { useLatestQuery } from "../../../WSUtils/useLatestQuery";
import { useLocStore } from "../../../wsLocalization";
import { LocContext } from "../../../wsLocalization/LocContext";
import { observer } from "mobx-react";
import { queryStringStore } from "../../../WSUtils/wsQueryStringStore";
import { sentryAssertData } from "../../../WSUtils/wsSentry";
import { id } from "date-fns/locale";
import { getRedirectProps } from "../../../WSUtils/urlUtils";
import { Button } from "primereact/button";
import CVEdit from "../CVEdit";
import { ConnectAccount } from "./ConnectAccount";
import { AuthInfo } from "./AuthInfo";

export const ProfilePage = observer(() => {
  const userInfo = useContext(UserInfoContext);
  const queryClient = useQueryClient();

  const L = useLocStore(LocContext.PROFILE);

  const { data: whoAmi } = useLatestQuery(["authAPI.whoAmi"], () =>
    userInfo.fullAPI.authAPI.whoAmi({ includeUnitIds: false, userInfo })
  );

  const { data: me } = useLatestQuery(["authAPI.me"], () =>
    userInfo.fullAPI.authAPI.me({ userInfo })
  );

  const { data: connectedProfiles } = useLatestQuery(
    ["authAPI.connectedProfiles"],
    () => userInfo.fullAPI.authAPI.connectedProfiles({ userInfo })
  );

  sentryAssertData([whoAmi, me, connectedProfiles], { userInfo });

  const nConnectedProfiles = connectedProfiles?.result?.length ?? 0;
  const showConnect = !!queryStringStore.qs.connect || nConnectedProfiles === 0;
  const isLoggedIn = !!whoAmi?.id;

  const isReady = !!whoAmi && !!me && !!connectedProfiles;

  return (
    <div>
      {isReady && (
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          {isLoggedIn && <AuthInfo />}
          {isLoggedIn && showConnect && <ConnectAccount />}
          {isLoggedIn && !showConnect && <CVEdit />}
          {!isLoggedIn && (
            <Button
              {...getRedirectProps("/login", {
                userInfo,
                mergeQs: null,
              })}
              className="p-button-primary"
            >
              {L.id("b4852fa50c5d").loc("Logg inn")}
            </Button>
          )}
        </div>
      )}
    </div>
  );
});
